var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bgWhite"},[_c('div',[_c('embed',{attrs:{"src":_vm.actualURL,"type":"application/pdf","width":"100%","height":"750"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }